/* Alpsland Blog – UX Helpers (mobile polish, duplicates fix, TOC, progress) */
(function () {
  const $ = (sel, ctx=document) => ctx.querySelector(sel);
  const $$ = (sel, ctx=document) => Array.from(ctx.querySelectorAll(sel));

  // Progress bar (support alps-progress typo)
  const progress = $('.alp-progress, .alps-progress');
  const content  = $('.alp-content');
  if (progress && content) {
    const update = () => {
      const max = content.offsetHeight - window.innerHeight + 120;
      const scrolled = Math.min(Math.max(window.scrollY - (content.offsetTop - 64), 0), max);
      const pct = max > 0 ? (scrolled / max) * 100 : 0;
      progress.style.width = `${pct}%`;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Lazy-load content images
  $$('.alp-content img:not([loading])').forEach(img => img.setAttribute('loading','lazy'));

  // External links: new tab + rel
  $$('.alp-content a[href^="http"]').forEach(a => {
    try{
      const host = location.host.replace(/^www\./,'');
      if (!a.href.includes(host)){ a.target = '_blank'; a.rel = 'nofollow noopener'; }
    } catch(_) {}
  });

  // Build TOC from h2/h3 (desktop)
  const tocList = $('.alp-toc nav ul');
  if (tocList && content) {
    const headings = $$('.alp-content h2, .alp-content h3');
    headings.forEach(h => {
      if (!h.id) {
        const slugBase = h.textContent.trim().toLowerCase().replace(/[^\w\s-]/g,'').replace(/\s+/g,'-').slice(0,80);
        let slug = slugBase, i=2; while (document.getElementById(slug)) slug = `${slugBase}-${i++}`;
        h.id = slug;
      }
      const a = document.createElement('a'); a.href = `#${h.id}`; a.textContent = h.textContent.trim();
      const li = document.createElement('li'); if (h.tagName === 'H3') li.className = 'lvl-3';
      li.appendChild(a); tocList.appendChild(li);
    });
    if (!tocList.children.length) { const box = $('.alp-toc'); if (box) box.style.display = 'none'; }
  }

  // Remove duplicate first H1 in content if equal to article title
  const heroTitle = $('.alp-hero h1')?.textContent?.trim() || '';
  const firstH1 = $('.alp-content h1');
  const norm = s => (s || '').replace(/\s+/g,' ').trim().toLowerCase();
  if (firstH1 && heroTitle && norm(firstH1.textContent) === norm(heroTitle)) firstH1.remove();

  // Hide in-content "Table of Contents"/"Inhalt" heading if we render our own TOC
  const inContentTOC = $$('.alp-content h2, .alp-content h3').find(h =>
    ['table of contents','inhalt'].includes(norm(h.textContent))
  );
  if (inContentTOC && $('.alp-toc')) {
    // remove heading + next list if it looks like a TOC
    const next = inContentTOC.nextElementSibling;
    if (next && (next.tagName === 'UL' || next.tagName === 'OL')) next.remove();
    inContentTOC.remove();
  }

  // Share buttons
  const shareBtn = $('#alp-btn-share');
  const copyBtn  = $('#alp-btn-copy');
  const shareData = { title: heroTitle || document.title, url: location.href };
  if (shareBtn) shareBtn.addEventListener('click', async () => {
    if (navigator.share) { try { await navigator.share(shareData); } catch(_){} }
    else {
      try { await navigator.clipboard.writeText(shareData.url); shareBtn.textContent='Link copied'; setTimeout(()=>shareBtn.textContent='Share',1200); } catch(_){}
    }
  });
  if (copyBtn) copyBtn.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(shareData.url); copyBtn.textContent='Copied ✓'; setTimeout(()=>copyBtn.textContent='Copy',1200);} catch(_){}
  });
})();